import { zodResolver } from '@hookform/resolvers/zod';
import {
    PrivateKrankenversicherungUndUnterhaltsverpflichtung,
    schemaId,
    SonstigeAusgabeUndMietAusgabe,
} from 'cpool-schemas';
import { z } from 'zod';

import { schemaRequiredAmount } from './requiredAmount.schema';

const schemaAmountAndId = z.object({
    betragMonatlich: schemaRequiredAmount,
    id: schemaId,
});

const schemaRentalOrOther = SonstigeAusgabeUndMietAusgabe.omit({
    betragMonatlich: true,
    id: true,
}).and(schemaAmountAndId);

const schemaInsuranceOrAliment = PrivateKrankenversicherungUndUnterhaltsverpflichtung.omit({
    betragMonatlich: true,
    id: true,
}).and(schemaAmountAndId);

export const schemaExpensesForm = z.object({
    mietausgaben: z.array(schemaRentalOrOther),
    privateKrankenversicherungen: z.array(schemaInsuranceOrAliment),
    sonstigeAusgaben: z.array(schemaRentalOrOther),
    unterhaltsverpflichtungen: z.array(schemaInsuranceOrAliment),
});

export type SchemaExpensesForm = z.infer<typeof schemaExpensesForm>;
export const resolverExpensesForm = zodResolver(schemaExpensesForm);
